// src/plugins/socket.js
import { io } from 'socket.io-client';

const socket = io(process.env.VUE_APP_SOCKET_URL, {
  autoConnect: false,
  transports: ['websocket']
});

export default socket;
